import { NavLink, Outlet } from "react-router-dom";

const subLinks = [
    { to: "/wmwe", label: "Home", end: true },
    { to: "/wmwe/fellowship", label: "Fellowship" },
    { to: "/wmwe/gatherings", label: "Gatherings" },
    { to: "/wmwe/hub", label: "Hub" },
    { to: "/wmwe/prayer", label: "Prayer Room" },
    { to: "/wmwe/about", label: "About" },
    { to: "/wmwe/shop", label: "Shop" },
];

export default function WMWELayout() {
    return (
        <div className="bg-sanct-sand" data-testid="wmwe-layout">
            <div className="pt-24 md:pt-28 bg-sanct-cocoa text-sanct-cream border-b border-sanct-clay/40">
                <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-6 flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
                    <div>
                        <p className="font-sans text-xs uppercase tracking-[0.3em] text-sanct-rose">A Sacred Fellowship</p>
                        <h2 className="font-serif italic text-3xl md:text-4xl tracking-tight">We Meet We Eat<sup className="text-[0.4em] not-italic ml-0.5 align-super opacity-70">&reg;</sup></h2>
                    </div>
                    <nav className="flex flex-wrap gap-x-6 gap-y-2">
                        {subLinks.map((l) => (
                            <NavLink
                                key={l.to}
                                to={l.to}
                                end={l.end}
                                data-testid={`wmwe-nav-${l.label.toLowerCase().replace(" ", "-")}`}
                                className={({ isActive }) =>
                                    `font-sans text-xs uppercase tracking-[0.18em] transition-colors ${
                                        isActive ? "text-sanct-rose" : "text-sanct-clay hover:text-sanct-rose"
                                    }`
                                }
                            >
                                {l.label}
                            </NavLink>
                        ))}
                    </nav>
                </div>
            </div>
            <Outlet />
        </div>
    );
}
